import Edit from "features/Order/Edit";

export default Edit;
